window.addEventListener('resize', () => {
  setTheRootFontSize()
})

window.document.addEventListener('DOMContentLoaded', () => {
  setTheRootFontSize()
})

// 关于视口宽高 https://juejin.cn/post/6844904022491529224
function setTheRootFontSize() {
  try {
    const tmpViewport = document.createElement('div')

    tmpViewport.style.width = '100vw'
    tmpViewport.style.height = '1px'
    tmpViewport.style.visibility = 'hidden'
    tmpViewport.style.opacity = '0'
    document.body.appendChild(tmpViewport)
    let viewportWidth: number = tmpViewport.offsetWidth
    const devicePixelRatio: number = window.devicePixelRatio

    if (!viewportWidth || !devicePixelRatio) {
      return
    }
    const standardWidth = 375

    // 用设备实际 css 宽，除以 375（iPhone6或iPhoneSE设备），即得到 rootElement fontSize
    // 430节点（iPhone14proMax）：大部分手机的最宽css像素数。当大于该节点咱们就不再等比例放大了。因为会让平板等设备的按钮/文字特别大。此时我们保持430不变。
    // 1024节点（ipadPro）。一般最大平板设备最宽就是1024了，再大就可以当作PC了。而pc设备下所有元素的px尺寸必须跟设计稿完全一致进行走查--因此我们需要html root fontSize保持为1，即跟iPhoneSE的375设备一模一样.
    viewportWidth = viewportWidth >= 430 ? (viewportWidth > 1024 ? 375 : 430) : viewportWidth // 超过1024就认为是pc吧，直接回归成1rem就等于1px从而可以以设计稿的px为单位布局。
    const rootFontSize = viewportWidth / standardWidth
    const rootEle: HTMLElement = document.documentElement || document.querySelector('html')

    if (rootEle && rootFontSize && !isNaN(Number(rootFontSize))) {
      rootEle.style.fontSize = `${rootFontSize}px`
      // rootEle.style.maxWidth = "1280px";
      rootEle.style.margin = '0 auto'
    }
  } catch (err) {
    console.error('calculate root fontSize error', err)
  }
}
